
class IntegratorConfigCell extends UITableViewCell
{
    private nameLabel: MUILabel = null;
    private sourceLabel: MUILabel = null;
    private syncLabel: MUILabel = null;
    private activeSwitch: MUISwitchButton = null;

    awakeFromHTML() {
        this.nameLabel = MUIOutlet(this, "name-lbl", "MUILabel");
        this.sourceLabel = MUIOutlet(this, "source-lbl", "MUILabel");
        this.syncLabel = MUIOutlet(this, "sync-lbl", "MUILabel");

        this.activeSwitch = MUIOutlet(this, "active-sw", "MUISwitchButton");
        this.activeSwitch.setOnChangeValue(this, function(this:IntegratorConfigCell, control: MUISwitchButton, on: boolean) {
            this._item.active = on;
        });
    }

    private _item: IntegratorConfig = null;
    set item(item: IntegratorConfig) {
        this._item = item;

        // The role is the config's identity to the server (the display name is free
        // text) — show it next to the name so the jobs read as what they are.
        let role = (item.configValues || {})["role"];
        this.nameLabel.text = role != null ? item.name + "  ·  " + role : item.name;
        this.sourceLabel.text = item.sourceEntityName;

        // How syncs move: manual (user pushes each one), semi-automatic (queued,
        // user confirms) or automatic. The switch is the config's on/off state —
        // the hook only generates syncs for active configs.
        this.syncLabel.text = item.type == 2 ? MIOLocalizeString("AUTOMATIC", "Automatic")
                            : item.type == 1 ? MIOLocalizeString("SEMI_AUTOMATIC", "Semi-automatic")
                            : MIOLocalizeString("MANUAL", "Manual");
        this.activeSwitch.on = item.active == true;
    }
}
